
import React, { Suspense, useMemo, useTransition } from "react";
import { useTranslation } from 'react-i18next';
import LoaderComponent from "components/common/Loader";
import { getDetailComponent } from "utils/moduleRegistry";

function DetailViewLayout({ selectedItem, setSelectedItem, context, list }) {
    const { t } = useTranslation();
    const [isPending, startTransition] = useTransition();

    const { Context, Component, link } = useMemo(() => {
        return getDetailComponent(selectedItem?.type);
    }, [selectedItem?.type]);

    if (!Component) {
        return <p>{t("detailView.noItemSelected", "No item selected")}</p>;
    }

    const handleSelect = (item) => {
        startTransition(() => {
            setSelectedItem(item);
        });
    };

    return (Context ? 
        <Context selectedItem={selectedItem} setSelectedItem={setSelectedItem} context={context} list={list}>
            <Suspense fallback={<LoaderComponent/>}>
                <Component/>
            </Suspense>
        </Context> 
    : 
        <Suspense fallback={<LoaderComponent/>}>
            <Component
                context={context}
                list={list}
                selectedItem={selectedItem}
                setSelectedItem={handleSelect}
            />
        </Suspense>);
}

export default DetailViewLayout;